import * as React from 'react';

import {
  Box,
  Container,
  IconButton,
  Link,
  Stack,
  Typography,
} from '@mui/material';

import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#171b23',
        color: 'rgba(255,255,255,.78)',
        py: { xs: 2.5, md: 3 },
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems="center"
          justifyContent="space-between"
          spacing={{ xs: 1.5, sm: 2 }}
        >
          <Box>
            <Typography
              sx={{
                color: '#fff',
                fontWeight: 700,
                lineHeight: 1.3,
                textAlign: { xs: 'center', sm: 'left' },
              }}
            >
              LCG Solution
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: 'rgba(255,255,255,.58)',
                lineHeight: 1.4,
              }}
            >
              © {new Date().getFullYear()} LCG Solution
            </Typography>
          </Box>

          <Link
            href="mailto:info@lcgsolution.com"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
              color: '#fff !important',
              fontWeight: 600,
            }}
          >
            <IconButton
              size="small"
              sx={{
                color: '#fff',
                bgcolor: 'rgba(255,255,255,.08)',
                '&:hover': {
                  bgcolor: 'rgba(255,255,255,.14)',
                },
              }}
            >
              <EmailOutlinedIcon fontSize="small" />
            </IconButton>

            info@lcgsolution.com
          </Link>
        </Stack>
      </Container>
    </Box>
  );
}